import { useEffect, useRef, useState } from 'react';

const S = {
  page:       { padding: '28px 20px', maxWidth: 1100, margin: '0 auto', fontFamily: 'Poppins, sans-serif' },
  title:      { fontSize: '1.6rem', fontWeight: 800, color: '#1a2a4a', marginBottom: 24, display: 'flex', alignItems: 'center', gap: 10 },
  stats:      { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: 14, marginBottom: 28 },
  statCard:   { background: '#fff', borderRadius: 14, padding: '16px 20px', boxShadow: '0 2px 12px rgba(0,0,0,0.07)', textAlign: 'center' },
  statNum:    { fontSize: '2rem', fontWeight: 800, lineHeight: 1 },
  statLabel:  { fontSize: '0.78rem', color: '#64748b', marginTop: 4 },
  toolbar:    { display: 'flex', gap: 10, marginBottom: 20, flexWrap: 'wrap', alignItems: 'center' },
  search:     { flex: 1, minWidth: 200, padding: '10px 14px', border: '1.5px solid #e2e8f0', borderRadius: 10, fontFamily: 'Poppins, sans-serif', fontSize: '0.9rem', outline: 'none' },
  filterBtn:  (active) => ({ padding: '8px 16px', borderRadius: 20, border: 'none', cursor: 'pointer', fontFamily: 'Poppins, sans-serif', fontSize: '0.82rem', fontWeight: 600, transition: 'all 0.2s', background: active ? '#4f46e5' : '#f1f5f9', color: active ? '#fff' : '#475569' }),
  card:       { background: '#fff', borderRadius: 14, padding: '16px 20px', boxShadow: '0 2px 10px rgba(0,0,0,0.06)', marginBottom: 10, display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 16 },
  avatar:     { width: 42, height: 42, borderRadius: '50%', background: 'linear-gradient(135deg,#4f46e5,#7c3aed)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#fff', fontWeight: 800, fontSize: '1.1rem', flexShrink: 0 },
  info:       { flex: 1, minWidth: 160 },
  name:       { fontWeight: 700, color: '#1a2a4a', fontSize: '0.95rem' },
  email:      { fontSize: '0.78rem', color: '#64748b', marginTop: 2 },
  meta:       { display: 'flex', gap: 20, flexWrap: 'wrap', alignItems: 'center' },
  metaItem:   { display: 'flex', flexDirection: 'column', alignItems: 'center' },
  metaVal:    { fontWeight: 700, fontSize: '0.95rem', color: '#1a2a4a' },
  metaKey:    { fontSize: '0.72rem', color: '#94a3b8', marginTop: 1 },
  actions:    { display: 'flex', gap: 8, flexWrap: 'wrap' },
  btn:        (color) => ({ padding: '7px 14px', borderRadius: 20, border: 'none', cursor: 'pointer', fontFamily: 'Poppins, sans-serif', fontSize: '0.8rem', fontWeight: 600, background: color, color: '#fff', display: 'flex', alignItems: 'center', gap: 5, transition: 'opacity 0.2s', whiteSpace: 'nowrap' }),
  empty:      { textAlign: 'center', padding: '48px 20px', color: '#94a3b8', fontSize: '0.95rem' },
  overlay:    { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.45)', zIndex: 500, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 },
  modal:      { background: '#fff', borderRadius: 18, padding: 28, width: '100%', maxWidth: 400, boxShadow: '0 12px 40px rgba(0,0,0,0.2)' },
  modalTitle: { fontSize: '1.1rem', fontWeight: 800, color: '#1a2a4a', marginBottom: 20 },
  field:      { marginBottom: 16 },
  label:      { display: 'block', fontSize: '0.82rem', fontWeight: 700, color: '#475569', marginBottom: 5 },
  input:      { width: '100%', padding: '10px 12px', border: '1.5px solid #e2e8f0', borderRadius: 10, fontFamily: 'Poppins, sans-serif', fontSize: '0.95rem', boxSizing: 'border-box', outline: 'none' },
  modalBtns:  { display: 'flex', gap: 10, justifyContent: 'flex-end', marginTop: 20 },
};

// Extrai só YYYY-MM-DD de qualquer formato de data (Date, ISO string, string simples)
function toYMD(val) {
  if (!val) return null;
  return String(val).split('T')[0];
}

function badge(aluno) {
  if (!aluno.dia_vencimento) return { label: 'Sem config', color: '#94a3b8', bg: '#f1f5f9' };
  const hoje = new Date(); hoje.setHours(0, 0, 0, 0);
  const venc = new Date(toYMD(aluno.data_proximo_vencimento) + 'T00:00:00');
  const diff = Math.round((venc - hoje) / 86400000);
  if (diff < 0)   return { label: 'Atrasado',   color: '#ef4444', bg: '#fef2f2' };
  if (diff === 0) return { label: 'Vence hoje', color: '#f59e0b', bg: '#fffbeb' };
  if (diff <= 3)  return { label: `${diff}d`,   color: '#3b82f6', bg: '#eff6ff' };
  return           { label: 'Em dia',           color: '#10b981', bg: '#f0fdf4' };
}

function initials(nome) {
  return (nome || '?').split(' ').slice(0, 2).map(w => w[0]).join('').toUpperCase();
}

function fmtDate(val) {
  if (!val) return '—';
  return new Date(toYMD(val) + 'T00:00:00').toLocaleDateString('pt-BR');
}

function fmtValor(val) {
  if (val == null) return '—';
  return new Intl.NumberFormat('pt-PT', { style: 'currency', currency: 'EUR' }).format(parseFloat(val));
}

const FILTERS = [
  { id: 'todos',     label: 'Todos' },
  { id: 'atrasado',  label: 'Atrasados' },
  { id: 'hoje',      label: 'Hoje' },
  { id: 'semconfig', label: 'Sem config' },
  { id: 'ok',        label: 'Em dia' },
];

export default function AdminAlunos() {
  const [alunos,   setAlunos]   = useState([]);
  const [loading,  setLoading]  = useState(true);
  const [search,   setSearch]   = useState('');
  const [filter,   setFilter]   = useState('todos');
  const [modal,    setModal]    = useState(null); // { id, nome, dia, valor }
  const [saving,   setSaving]   = useState(false);
  const [toast,    setToast]    = useState(null);
  const toastTimer = useRef(null);

  function showToast(msg, type = 'success') {
    setToast({ msg, type });
    clearTimeout(toastTimer.current);
    toastTimer.current = setTimeout(() => setToast(null), 3500);
  }

  async function load() {
    setLoading(true);
    try {
      const r = await fetch('/admin/alunos-json', { credentials: 'include' });
      setAlunos(await r.json());
    } catch { showToast('Erro ao carregar alunos.', 'error'); }
    setLoading(false);
  }

  useEffect(() => { load(); }, []); // eslint-disable-line

  async function salvar() {
    if (!modal.dia || !modal.valor || !modal.dataVenc) return;
    setSaving(true);
    try {
      const r = await fetch('/admin/aluno-mensalidade', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ userId: modal.id, diaVencimento: modal.dia, valor: modal.valor, dataProximoVencimento: modal.dataVenc }),
      });
      const d = await r.json();
      if (d.success) {
        showToast('Mensalidade salva!');
        setModal(null);
        load();
      } else { showToast(d.message, 'error'); }
    } catch { showToast('Erro ao salvar.', 'error'); }
    setSaving(false);
  }

  async function marcarPago(id, nome) {
    if (!window.confirm(`Confirmar pagamento de ${nome}? O próximo vencimento será avançado em 1 mês.`)) return;
    try {
      const r = await fetch(`/admin/aluno-pago/${id}`, { method: 'POST', credentials: 'include' });
      const d = await r.json();
      if (d.success) {
        showToast(`Pago! Próx. venc.: ${new Date(d.novoVencimento + 'T00:00:00').toLocaleDateString('pt-BR')}`);
        load();
      } else { showToast(d.message, 'error'); }
    } catch { showToast('Erro.', 'error'); }
  }

  async function toggleAluno(id, nome, ativo) {
    if (!window.confirm(`${ativo ? 'Desativar' : 'Ativar'} ${nome} como aluno?`)) return;
    try {
      const r = await fetch('/admin/toggle-student', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ userId: id }),
      });
      const d = await r.json();
      if (d.success) { showToast('Status atualizado!'); load(); }
      else showToast(d.message, 'error');
    } catch { showToast('Erro.', 'error'); }
  }

  async function toggleVozIA(id, nome, atual) {
    const acao = atual ? 'Desativar' : 'Ativar';
    if (!window.confirm(`${acao} Voz IA para ${nome}?`)) return;
    try {
      const r = await fetch('/admin/toggle-voz-ia', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ userId: id }),
      });
      const d = await r.json();
      if (d.success) { showToast(`Voz IA ${d.voz_ia ? 'ativada' : 'desativada'} para ${nome}!`); load(); }
      else showToast(d.message, 'error');
    } catch { showToast('Erro.', 'error'); }
  }

  const hoje = new Date(); hoje.setHours(0, 0, 0, 0);

  const vencDate = (a) => a.data_proximo_vencimento
    ? new Date(toYMD(a.data_proximo_vencimento) + 'T00:00:00')
    : null;

  const stats = {
    total:    alunos.length,
    atrasado: alunos.filter(a => { const d = vencDate(a); return d && d < hoje; }).length,
    hoje:     alunos.filter(a => { const d = vencDate(a); return d && Math.round((d - hoje) / 86400000) === 0; }).length,
    semconfig: alunos.filter(a => !a.dia_vencimento).length,
  };

  const visible = alunos.filter(a => {
    const term = search.toLowerCase();
    if (term && !a.nome.toLowerCase().includes(term) && !a.email.toLowerCase().includes(term)) return false;
    const d = vencDate(a);
    if (filter === 'semconfig') return !a.dia_vencimento;
    if (filter === 'atrasado') return d && d < hoje;
    if (filter === 'hoje')     return d && Math.round((d - hoje) / 86400000) === 0;
    if (filter === 'ok')       return d && d > hoje;
    return true;
  });

  return (
    <div style={S.page}>

      {/* Título */}
      <h1 style={S.title}>
        <i className="fas fa-graduation-cap" style={{ color: '#4f46e5' }} />
        Gerenciar Alunos
      </h1>

      {/* Stats */}
      <div style={S.stats}>
        {[
          { num: stats.total,     label: 'Total de alunos', color: '#4f46e5' },
          { num: stats.atrasado,  label: 'Atrasados',       color: '#ef4444' },
          { num: stats.hoje,      label: 'Vencem hoje',     color: '#f59e0b' },
          { num: stats.semconfig, label: 'Sem configuração',color: '#94a3b8' },
        ].map(s => (
          <div key={s.label} style={S.statCard}>
            <div style={{ ...S.statNum, color: s.color }}>{s.num}</div>
            <div style={S.statLabel}>{s.label}</div>
          </div>
        ))}
      </div>

      {/* Toolbar */}
      <div style={S.toolbar}>
        <input
          style={S.search}
          placeholder="Buscar por nome ou email..."
          value={search}
          onChange={e => setSearch(e.target.value)}
        />
        {FILTERS.map(f => (
          <button key={f.id} style={S.filterBtn(filter === f.id)} onClick={() => setFilter(f.id)}>
            {f.label}
            {f.id === 'atrasado' && stats.atrasado > 0 && (
              <span style={{ background: '#ef4444', color: '#fff', borderRadius: 9, padding: '1px 6px', fontSize: '0.7rem', marginLeft: 5 }}>
                {stats.atrasado}
              </span>
            )}
          </button>
        ))}
      </div>

      {/* Lista */}
      {loading ? (
        <div style={S.empty}><i className="fas fa-spinner fa-spin" /> Carregando...</div>
      ) : visible.length === 0 ? (
        <div style={S.empty}>Nenhum aluno encontrado.</div>
      ) : visible.map(a => {
        const b = badge(a);
        return (
          <div key={a.id} style={{ ...S.card, borderLeft: `4px solid ${b.color}` }}>

            {/* Avatar */}
            <div style={S.avatar}>{initials(a.nome)}</div>

            {/* Info */}
            <div style={S.info}>
              <div style={S.name}>{a.nome}</div>
              <div style={S.email}>{a.email}</div>
            </div>

            {/* Meta */}
            <div style={S.meta}>
              <div style={S.metaItem}>
                <span style={{ ...S.metaVal, background: b.bg, color: b.color, borderRadius: 20, padding: '3px 10px', fontSize: '0.8rem' }}>
                  {b.label}
                </span>
                <span style={S.metaKey}>status</span>
              </div>
              <div style={S.metaItem}>
                <span style={S.metaVal}>{a.dia_vencimento ? `Dia ${a.dia_vencimento}` : '—'}</span>
                <span style={S.metaKey}>vencimento</span>
              </div>
              <div style={S.metaItem}>
                <span style={S.metaVal}>{fmtValor(a.valor)}</span>
                <span style={S.metaKey}>mensalidade</span>
              </div>
              <div style={S.metaItem}>
                <span style={S.metaVal}>{fmtDate(a.data_proximo_vencimento)}</span>
                <span style={S.metaKey}>próx. venc.</span>
              </div>
            </div>

            {/* Ações */}
            <div style={S.actions}>
              <button
                style={S.btn('#4f46e5')}
                onClick={() => {
                  const existingDate = a.data_proximo_vencimento
                    ? String(a.data_proximo_vencimento).split('T')[0]
                    : '';
                  setModal({ id: a.id, nome: a.nome, dia: a.dia_vencimento || '', valor: a.valor || '', dataVenc: existingDate });
                }}
              >
                <i className="fas fa-cog" />
                {a.dia_vencimento ? 'Editar' : 'Configurar'}
              </button>
              {a.dia_vencimento && (
                <button style={S.btn('#10b981')} onClick={() => marcarPago(a.id, a.nome)}>
                  <i className="fas fa-check" /> Pago
                </button>
              )}
              <button
                style={{
                  ...S.btn(a.voz_ia ? '#7c3aed' : '#e2e8f0'),
                  color: a.voz_ia ? '#fff' : '#475569',
                  border: a.voz_ia ? 'none' : '1.5px solid #cbd5e1',
                }}
                onClick={() => toggleVozIA(a.id, a.nome, a.voz_ia)}
                title={a.voz_ia ? 'Desativar Voz IA' : 'Ativar Voz IA'}
              >
                <i className="fas fa-microphone" />
                {a.voz_ia ? 'Voz IA ✓' : 'Voz IA'}
              </button>
              <button
                style={S.btn('#94a3b8')}
                onClick={() => toggleAluno(a.id, a.nome, true)}
                title="Remover status de aluno"
              >
                <i className="fas fa-user-minus" />
              </button>
            </div>

          </div>
        );
      })}

      {/* Modal configurar mensalidade */}
      {modal && (
        <div style={S.overlay} onClick={e => e.target === e.currentTarget && setModal(null)}>
          <div style={S.modal}>
            <div style={S.modalTitle}>
              <i className="fas fa-cog" style={{ color: '#4f46e5', marginRight: 8 }} />
              Mensalidade — {modal.nome}
            </div>

            <div style={S.field}>
              <label style={S.label}>Dia de vencimento mensal (1–31)</label>
              <input
                style={S.input}
                type="number" min="1" max="31"
                placeholder="Ex: 15"
                value={modal.dia}
                onChange={e => setModal(m => ({ ...m, dia: e.target.value }))}
                onFocus={e => e.target.style.borderColor = '#4f46e5'}
                onBlur={e => e.target.style.borderColor = '#e2e8f0'}
              />
            </div>

            <div style={S.field}>
              <label style={S.label}>
                Próxima data de vencimento
                <span style={{ fontWeight: 400, color: '#94a3b8', marginLeft: 6, fontSize: '0.75rem' }}>
                  — defina manualmente conforme situação do aluno
                </span>
              </label>
              <input
                style={S.input}
                type="date"
                value={modal.dataVenc}
                onChange={e => setModal(m => ({ ...m, dataVenc: e.target.value }))}
                onFocus={e => e.target.style.borderColor = '#4f46e5'}
                onBlur={e => e.target.style.borderColor = '#e2e8f0'}
              />
              <div style={{ fontSize: '0.75rem', color: '#94a3b8', marginTop: 4 }}>
                Já pagou este mês? Coloque o 1º dia do próximo mês de vencimento.
                Está devendo? Coloque a data que deveria ter pago.
              </div>
            </div>

            <div style={S.field}>
              <label style={S.label}>Valor da mensalidade (EUR)</label>
              <input
                style={S.input}
                type="number" min="0.01" step="0.01"
                placeholder="Ex: 80.00"
                value={modal.valor}
                onChange={e => setModal(m => ({ ...m, valor: e.target.value }))}
                onFocus={e => e.target.style.borderColor = '#4f46e5'}
                onBlur={e => e.target.style.borderColor = '#e2e8f0'}
              />
            </div>

            <div style={S.modalBtns}>
              <button
                style={{ ...S.btn('#e2e8f0'), color: '#475569' }}
                onClick={() => setModal(null)}
              >
                Cancelar
              </button>
              <button
                style={S.btn(saving ? '#94a3b8' : '#4f46e5')}
                onClick={salvar}
                disabled={saving || !modal.dia || !modal.valor || !modal.dataVenc}
              >
                <i className={`fas fa-${saving ? 'spinner fa-spin' : 'save'}`} />
                {saving ? 'Salvando...' : 'Salvar'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Toast */}
      {toast && (
        <div style={{
          position: 'fixed', bottom: 90, right: 24, padding: '11px 22px',
          borderRadius: 10, color: '#fff', fontSize: '0.88rem', fontWeight: 600,
          zIndex: 9999, fontFamily: 'Poppins, sans-serif',
          background: toast.type === 'success' ? '#059669' : '#dc2626',
          boxShadow: '0 4px 16px rgba(0,0,0,0.15)',
        }}>
          {toast.msg}
        </div>
      )}

    </div>
  );
}
